var map = {
	"./add_kjdy_success.png": 1211,
	"./allchat.png": 1212,
	"./caitaxihuan.png": 1213,
	"./coupon.png": 1214,
	"./coupon_hover.png": 1215,
	"./dealuser.png": 1216,
	"./dkhsqsh.png": 1217,
	"./dkhsqsh_hover.png": 1218,
	"./dr_alert1.png": 1219,
	"./dr_alert1a.png": 1220,
	"./dr_alert2.png": 1221,
	"./emoj.png": 1222,
	"./goodmsg.png": 1223,
	"./jbalert.png": 1224,
	"./jbeykh.png": 1225,
	"./jbeysh.png": 1226,
	"./kjdy_alert.png": 1227,
	"./kjdy_alert_hover.png": 1228,
	"./kjdy_dr_done.jpeg": 1229,
	"./kjdy_drdc.jpeg": 1230,
	"./kjdy_raw.png": 1231,
	"./kjhf1.jpeg": 1232,
	"./kjhf_add.jpeg": 1233,
	"./kjhf_add_group.jpeg": 1234,
	"./kjhf_add_group_success.jpeg": 1235,
	"./kjhf_add_new.jpeg": 1236,
	"./kjhf_add_select_group.jpeg": 1237,
	"./link.png": 1238,
	"./link_hover.png": 1239,
	"./llzj.png": 1240,
	"./login1.png": 1241,
	"./login2.png": 1242,
	"./login3.png": 1243,
	"./loginindex.png": 1244,
	"./ltjl.png": 1245,
	"./markend.png": 1246,
	"./more_feature.png": 1247,
	"./order1.png": 1248,
	"./order2.png": 1249,
	"./order3.png": 1250,
	"./order_hover.png": 1251,
	"./orderremark1.png": 1252,
	"./orderremark2.png": 1253,
	"./other.png": 1254,
	"./pddbg1.png": 1255,
	"./pddbg2.png": 1256,
	"./qtalert.png": 1257,
	"./quitpdd.png": 1258,
	"./rexiao.png": 1259,
	"./rnd1.png": 1260,
	"./rnd2.png": 1261,
	"./send_kjdy.png": 1262,
	"./sjmb.png": 1263,
	"./status_bar_left.png": 1264,
	"./status_bar_right.png": 1265,
	"./status_menu1.png": 1266,
	"./status_menu2.png": 1267,
	"./statusonline.png": 1268,
	"./statusonline1.png": 1269,
	"./staus.png": 1270,
	"./sucaiku.png": 1271,
	"./sucaikubtn.png": 1272,
	"./tag.png": 1273,
	"./tagsuccess.png": 1274,
	"./tjsp.png": 1275,
	"./tjsp2.png": 1276,
	"./undealuser.png": 1277,
	"./untagsuccess.png": 1278,
	"./untagsuccessbg.png": 1279,
	"./video.png": 1280,
	"./xedk.png": 1281,
	"./xesk.png": 1282,
	"./zyhh1.png": 1283,
	"./zyhh2.png": 1284
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1210;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd ^\.\/.*$
// module id = 1210
// module chunks = 0